<template>
  <div>
    <div class="bg-primary fixed-top text-white pb-1">
      <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center" style="height: 36px">
          <router-link class="text-white text-decoration-none small pt-1" to="/home"><i class="fa fa-chevron-left mr-2"></i><b>{{ usuario.nome_fantasia }}</b></router-link>
          <div>
            <button class="btn text-white btn-topbar" title="Finalizar todos" @click="alterarEmMassa()">
              <i class="fa fa-check-double mr-1" style="width: 20px"></i>
            </button>
            <button class="btn text-white btn-topbar" title="Sincronizar" @click="getPedidos()">
              <i class="fa fa-sync-alt mr-1" style="width: 20px"></i>
            </button>
            <button class="btn text-white btn-topbar" title="Configs" @click="modalConfigs = true">
              <i class="fa fa-cog mr-1" style="width: 20px"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container-monitor bg-light">
      <div class="container-fluid">
        <div class="row no-gutters">
          <div class="col-6 col-md-3 col-lg-2 pr-1 pr-md-2 mb-3 mb-md-0">
            <button :class="pesquisa.status === '1' ? 'btn-primary' : 'btn-outline-dark'" class="btn btn-block text-nowrap mr-2" @click="filtrar('1')">
              <i class="fa fa-clock mr-1"></i> Aguardando
            </button>
          </div>
          <div class="col-6 col-md-3 col-lg-2 pr-md-2 mb-3 mb-md-0">
            <button :class="pesquisa.status === '2' ? 'btn-third' : 'btn-outline-dark'" class="btn btn-block text-nowrap px-3" @click="filtrar('2')">
              <i class="fa fa-check mr-1"></i> Preparando
            </button>
          </div>
          <div class="col-6 col-md-3 col-lg-2 pr-1 pr-md-2 ml-auto">
            <select v-model="tipo_comanda" class="form-control">
              <option value="">Todos</option>
              <option value="1">Mesa</option>
              <option value="2">Delivery</option>
              <option value="3">Comanda</option>
              <option value="5">Balcão</option>
            </select>
          </div>
          <div class="col-6 col-md-3 col-lg-2">
            <input v-model="search" class="form-control" placeholder="Pesquisar pedido" type="number">
          </div>
        </div>

        <hr>
        <loading v-if="load"/>

        <div class="row no-gutters" v-show="!load">
          <div class="col-md-12" v-show="search.length">
            <div class="alert alert-warning d-flex align-items-center">
              <i class="fa fa-filter ml-1 mr-2"></i>
              <div>Filtro de pesquisa ativado</div>
              <div class="ml-auto text-nowrap"><a class="text-dark" href="javascript:" @click="clearPesquisa()"><u>Limpar</u></a></div>
            </div>
          </div>
          <div v-for="pedido in pedidosFiltrados" :key="pedido.id_pedido" class="col-md-4 col-lg-3 px-1 mb-3">
            <div class="card border-dark">
              <div class="card-header bg-light d-flex">
                <div class="pointer" @click="selPedido(pedido.id_pedido)">
                  <a class="mb-0 text-dark" href="javascript:">
                    <b class="text-primary">#{{pedido.id_contador}}</b> - <span class="small">{{pedido | tipo }}</span>
                  </a>
                  <div>
                    <span class="badge badge-dark mr-1"><i class="fa fa-clock"></i> <clock :time="pedido.tempo_pedido"/></span>
                    <span class="badge badge-success" title="Este pedido deverá ser entregue ao cliente" v-if="pedido.tipo_pedido === '1'">Entregar</span>
                    <span class="badge badge-primary" title="Este pedido será retirado no estabelecimento" v-else-if="pedido.tipo_pedido === '2'">Retirar</span>
                    <span class="badge badge-warning" title="Este pedido será consumido no estabelecimento" v-else>Consumir</span>
                  </div>
                </div>
                <button class="btn text-secondary ml-auto px-2" @click="imprimir(pedido.id_pedido)">
                  <i class="fa fa-print"></i>
                </button>
              </div>
              <div v-if="pedido.produtos" class="card-body p-2">
                <div v-for="p in pedido.produtos" :key="p.id_comanda_produto" class="mb-2">
                  <div>
                    <label class="h6 font-weight-bold mb-0">
                      <span v-if="p.id_medida === '2'">{{p.quantidade + 'kg'}}</span><span v-else-if="p.quantidade">{{p.quantidade | qtd}}x</span> - {{p.nome_produto}}
                    </label>
                    <div v-for="d in p.divisao" :key="d.id_comanda_produto" class="small"># {{d.nome_produto}}</div>
                    <div v-for="a in p.adicionais" :key="a.id_comanda_produto" class="small">
                      + <span v-if="(a.quantidade / p.quantidade) > 1">{{(a.quantidade / p.quantidade) | qtd}}x</span> {{a.nome_produto}}
                    </div>
                    <div v-show="p.observacao" class="small">Obs: <b>{{p.observacao}}</b></div>
                  </div>
                </div>
                <div v-if="pedido.obs_pedido" class="font-weight-bold mt-2">OBS: {{pedido.obs_pedido}}</div>
              </div>
              <div class="card-footer bg-white p-2">
                <div class="d-flex mt-2" v-if="pedido.status === '1'">
                  <div class="w-50 mr-1"><button class="btn btn-third btn-block" @click="editarPedidos(pedido, '3')">Concluir</button></div>
                  <div class="w-50"><button class="btn btn-success btn-block" @click="editarPedidos(pedido, '2')">Iniciar</button></div>
                </div>
                <div class="d-flex mt-2" v-else>
                  <div class="w-50 mr-1"><button class="btn btn-primary btn-block" @click="editarPedidos(pedido, '1')">Desfazer</button></div>
                  <div class="w-50"><button class="btn btn-third btn-block" @click="editarPedidos(pedido, '3')">Concluir</button></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-bottom :opened="modalPedido" noPad="true">
      <div class="container-cupom">
        <loading v-if="!pedido"/>
        <cupom-pedido id="cupomListaPedidos" :pedido="pedido" show="true"/>
      </div>
      <div class="border-top text-center p-3">
        <button class="btn btn-dark px-4" @click="modalPedido = false">Fechar</button>
      </div>
    </modal-bottom>

    <modal-bottom :opened="modalConfigs" noPad="true">
      <div class="container-cupom">
        <h6 class="text-center mb-0 font-weight-bold">Configurações</h6>
        <hr>
        <div class="form-group">
          <label class="mb-0">Exibição do pedido</label>
          <select v-model="pesquisa.full" class="form-control" @change="salvarConfigs()">
            <option :value="false">Forma resumida</option>
            <option :value="true">Mostrar produtos</option>
          </select>
        </div>
        <div class="form-group">
          <label class="mb-0">Iniciar pedido</label>
          <select v-model="auto_print" class="form-control" @change="salvarConfigs()">
            <option :value="false">Não imprimir</option>
            <option :value="true">Imprimir</option>
          </select>
        </div>
        <div v-show="false" class="form-group">
          <label class="mb-0">
            <input type="checkbox" @change="alterDevice = !alterDevice"> Alterar impressora
          </label>
          <input v-model="pesquisa.device" :disabled="!alterDevice" class="form-control" placeholder="Nome da impressora" type="text">
        </div>
      </div>
      <div class="border-top text-center p-3">
        <button class="btn btn-dark px-4" @click="modalConfigs = false">Fechar</button>
      </div>
    </modal-bottom>
  </div>
</template>

<script>
  import Loading from "../../components/gestor/loading";
  import ModalBottom from "../../components/gestor/ModalGestor";
  import CupomPedido from "../comanda/pdv/CupomPedido"
  import Clock from "@/components/commons/Clock";

  export default {
    name: 'Monitor',
    components: {Clock, ModalBottom, CupomPedido, Loading},
    data() {
      return {
        token: localStorage.getItem('key'),
        empresaToken: localStorage.getItem('token'),
        load: false,
        pedidosCache: [],
        pesquisa: { status: '1', full: false, device: '' },
        pedido: null,
        tipo_comanda: '',
        search: '',

        pageVisible: true,
        intervalPedidos: null,
        intervalTempo: null,

        modalPedido: false,
        modalConfigs: false,
        alterDevice: false,
        auto_print: false,

        reconnectTimer: null,
        modalOffline: false
      }
    },

    methods: {
      filtrar(status) {
        this.pesquisa.status = status || this.pesquisa.status;
        this.getPedidos();
      },

      clearPesquisa() {
        this.search = "";
      },

      getPedidos(noLoad, id_pedido = null) {
        if (!this.pageVisible) {
          return;
        }

        this.load = !noLoad;
        this.$http.get('pdv/pedidos/' + this.token, { params: { ...this.pesquisa, id_pedido } })
          .then(response => {
            this.load = false;
            const pedidos = response.data || [];

            if (!id_pedido) {
              this.pedidosCache = pedidos;

            } else if (!this.pedidosCache.find(p => parseInt(p.id_pedido) === id_pedido)) {
              const novoPedido = pedidos.length ? pedidos[0] : null;

              if (novoPedido) {
                this.pedidosCache.push(novoPedido);
              }
            }

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      editarPedidos(pedido, status) {
        pedido.status = status;
        const imprimir = status === '2' && this.auto_print;

        if (this.pesquisa.status > 0) {
          this.pedidosCache = this.pedidosCache.filter(p => p.id_pedido !== pedido.id_pedido);
          this.clearPesquisa();
        }

        if (imprimir) {
          this.$store.state.load = 'Imprimindo..';
        }

        this.$http.post('pdv/pedido/editar/' + this.token, { id_pedido: pedido.id_pedido, status })
          .then(res => {
            this.$store.state.load = false;

            if (res.data && res.data.success) {
              this.$socket.emit('comanda_order', { token: this.empresaToken, content: { id_pedido: pedido.id_pedido, status } });

              if (imprimir) {
                this.imprimir(pedido.id_pedido);
              }

            } else {
              this.getPedidos();
            }

          }, res => {
            this.$store.state.load = false;
            this.getPedidos();
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      alterarEmMassa() {
        if (!this.pedidosCache.length) {
          this.$swal('Não há pedidos na tela');
          return;
        }

        this.$swal({
          text: "Deseja limpar todos os pedidos desta tela?",
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            const status = parseInt(this.pesquisa.status) + 1;
            const pedidos = this.pedidosCache.map(p => p.id_pedido);
            this.load = true;

            this.$http.post('pdv/pedido/editar/' + this.token, { pedidos, status })
              .then(res => {
                this.load = false;

                if (res.data && res.data.success) {
                  this.$socket.emit('comanda_order', { token: this.empresaToken, content: { clear: true, status: this.pesquisa.status } });
                  this.pedidosCache = [];
                  this.clearPesquisa();

                } else {
                  this.getPedidos();
                }

              }, res => {
                this.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
              });
          }
        });
      },

      selPedido(id_pedido) {
        this.modalPedido = true;
        this.pedido = null;

        this.$http.get('pdv/pedido/' + this.token + '?id_pedido=' + id_pedido)
          .then(response => {
            if (response.data?.id_pedido) {
              this.pedido = response.data;
            }

          }, res => {
            this.$swal(res.data?.msg || 'Erro Temporário');
          });
      },

      imprimir(id_pedido) {
        this.$store.state.load = 'Imprimindo..';
        const imprimir = this.isElectron || !this.impressora.mobilePrint;

        this.$http.get(`comprovante/pedido/${this.empresaToken}/${id_pedido}`, { params: { imprimir } })
          .then(res => {
            this.$store.state.load = false;
            const id_impressao = res.data?.id_impressao || null;

            if (imprimir && !id_impressao) {
              this.$swal('Não foi possível imprimir este pedido, por favor tente novamente.');
              return;
            }

            if (imprimir) {
              this.$helpers.awaitImpressao(this, id_impressao, 10000, 1);

            } else {
              this.$helpers.popUpimpressao(res.data);
            }

          }, res => {
            console.log(res);
            this.$store.state.load = false;
            this.$swal(res.data?.msg || 'Erro temporário');
          });
      },

      salvarConfigs() {
        const configs = { ...this.pesquisa, auto_print: this.auto_print }
        localStorage.setItem('monitorConfigs', JSON.stringify(configs));
        this.modalConfigs = false;
        this.getPedidos();
      },

      setConfigs() {
        const configs = this.$helpers.parseJSONObject(localStorage.getItem('monitorConfigs'));

        if (configs) {
          this.pesquisa.full = configs.full || false;
          this.pesquisa.status = configs.status || '1';
          this.auto_print = configs.auto_print || false;
        }
      },

      startIntervals() {
        if (!this.intervalTempo) {
          this.intervalTempo = setInterval(() => {
            this.pedidosCache.forEach((p) => {
              p.tempo_pedido = parseInt(p.tempo_pedido || '0') + 1;
            });

          }, 60 * 1000);
        }

        if (!this.intervalPedidos) {
          this.intervalPedidos = setInterval(() => {
            this.getPedidos(true);
          }, 4 * 60 * 1000);
        }

        this.getPedidos();
      },

      stopIntervals() {
        if (this.intervalPedidos) {
          clearInterval(this.intervalPedidos);
          this.intervalPedidos = null;
        }

        if (this.intervalTempo) {
          clearInterval(this.intervalTempo);
          this.intervalTempo = null;
        }
      },

      handleVisibilityChange() {
        this.pageVisible = document.visibilityState === 'visible';

        if (this.pageVisible) {
          this.startIntervals();
        }

        if (document.visibilityState === 'hidden') {
          this.stopIntervals();
        }
      }
    },

    mounted() {
      this.setConfigs();
      this.startIntervals();
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },

    sockets: {
      comanda_order(data) {
        if (!data) {
          return;
        }

        const statusEvento = data?.status ? parseInt(data.status) : 1;
        const statusTela = parseInt(this.pesquisa.status);

        if (statusEvento === statusTela && data.clear) {
          this.getPedidos();
          return;
        }

        if (data.id_pedido) {
          const id_pedido = parseInt(data.id_pedido);

          // Caso status igual -> carregar pedido
          if (statusEvento === statusTela) {
            this.getPedidos(true, id_pedido);

          } else {
            // Caso status diferente -> remover pedido
            this.pedidosCache = this.pedidosCache.filter(p => parseInt(p.id_pedido) !== id_pedido);
          }
        }
      },

      connect() {
        if (!this.reconnectTimer) {
          this.reconnectTimer = setTimeout(() => {
            this.getPedidos(true);
            this.reconnectTimer = null;
          }, 1000 * 5);
        }
      },

      disconnect() {
        if (this.reconnectTimer) {
          clearTimeout(this.reconnectTimer);
          this.reconnectTimer = null;
        }
      }
    },

    filters: {
      valor(value) {
        if (value !== null && value !== undefined && value !== '') {
          const n = Number(value);
          return Number.isFinite(n) ? n.toFixed(2) : '0.00';
        }

        return '0.00';
      },

      qtd(value) {
        if (value !== null && value !== undefined && value !== '') {
          const n = Number(value);
          return Number.isFinite(n) ? n.toFixed(0) : '0';
        }
      },

      tipo(pedido) {
        switch (pedido.tipo_comanda) {
          case '1':
            return "Mesa: " + pedido.mesa;

          case '2':
            return "Delivery: " + pedido.id_venda;

          case '3':
            return "Comanda: " + pedido.ref_comanda;

          case '4':
            return "Venda Rápida";

          default:
            return "Balcão";
        }
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      impressora() {
        return this.$store.state.impressora
      },

      pedidosFiltrados() {
        let lista = this.pedidosCache || [];
        const search = String(this.search).trim();

        if (search) {
          lista = lista.filter(p => String(p.id_contador) === search || String(p.id_venda) === search);
        }

        if (this.tipo_comanda) {
          lista = lista.filter(p => p.tipo_comanda === this.tipo_comanda);
        }

        return lista;
      }
    },

    beforeDestroy() {
      this.stopIntervals();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);

      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    }
  }
</script>

<style scoped>
  .container-monitor {
    padding: 56px 0 16px;
    min-height: 100vh;
  }

  .container-cupom {
    height: 400px;
    overflow: auto;
    padding: 16px 24px;
  }

  .container-monitor .card-header {
    padding: 10px;
  }

  .btn-topbar {
    line-height: 0;
    padding: 0 6px 0 6px;
  }

  @media (max-width: 767px) {
    .container-cupom {
      max-height: 65vh;
    }
  }
</style>
